module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }